import * as React from 'react';
import { Legend } from '../../../Legend';
import { AvgToggle } from './AvgToggle';

interface Props {
  showHistoric: boolean;
  showAverage: boolean;
  showHistoricAverage: boolean;
  setShowAverage: (showAverage: boolean) => void;
  setShowHistoricAverage: (showHistoricAverage: boolean) => void;
}

export const Toolbar: React.FC<Props> = (props) => {
  const { showHistoric, showAverage, showHistoricAverage, setShowAverage, setShowHistoricAverage } =
    props;
  return (
    <div className="flex items-center gap-8 flex-wrap md:flex-nowrap">
      <Legend showHistoric={showHistoric} />
      <div className="flex items-center gap-8">
        <AvgToggle value={showAverage} setValue={setShowAverage} variant="current" />
        {showHistoric ? (
          <AvgToggle
            value={showHistoricAverage}
            setValue={setShowHistoricAverage}
            variant="historic"
          />
        ) : null}
      </div>
    </div>
  );
};
Toolbar.displayName = 'Shipments.HistoricalPerDiem.ChargesOverTime.Toolbar';
